module.exports = __webpack_public_path__ + "img/horizontal_3_2_5010.9a993326.png";